















import BaseComponent from '@/components/base-component.vue';
import UiCepFormat from '@/components/UI/cep-format.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import PatientAddress from './patient-address.vue';

@Component({
  components: { PermissionAuth, UiCepFormat, PatientAddress },
})
export default class PatientAddressMultiClientUnit extends BaseComponent {
  @Prop()
  public item!: any;

  @Prop()
  public idUniqueEditClientUnit: any;

  keyTab = 0;
  keyIcon = 0;

  currentTab = 0;

  unitsOk = [];

  @Watch('item.unidades', {deep: true, immediate: true})
  onUnidadesChange() {
    this.keyTab++;
  }

  @Watch('item.ativo', {immediate: true})
  onAtivoChange() {
    this.forceChangeIcon();
  }

  onValidAddress(ok, unit) {
    this.unitsOk[unit.id] = ok;
    this.forceChangeIcon();
  }

  forceChangeIcon() {
    this.keyIcon++;
  }

  isUnitOk(id) {
    return this.unitsOk[id] == undefined || this.unitsOk[id];
  }
  
}
